/**
 * @flow
 * @format
 */

import React from 'react';
import { Col, Input, FormGroup } from 'reactstrap';
import _ from 'lodash';

import { branch, deepDiffer } from '~/utils';
import Aux from '~/utils/react-aux';
import debug from '~/utils/macros/debug.macro';
import RevertInput from '../RevertInput';

import fieldWrapperClasses from '../FieldWrapper/FieldWrapper.scss';
// import classes from './FieldDropdown.scss';

type PropsType = {
  changed: boolean,
  changeInput: Function,
  defaultVal: number | string | null,
  error: string[],
  fieldName: string | ReactElementType,
  multiple?: boolean,
  options: Array<any>,
  revertInput: Function,
  tooltip: string | ReactElementType,
  warning: string[],
  value: string | number | null,
};

export class FieldDropdown extends React.Component<PropsType, *> {
  static defaultProps = {
    options: [],
    error: [],
    warning: [],
    fieldName: <div />,
    multiple: false,
  };

  props: PropsType; // eslint-disable-line react/sort-comp
  onChangeHandler: mixed;

  constructor(props: PropsType) {
    super(props);

    // We need a better change handler to take care of multiple
    this.onChangeHandler = (e: any) => {
      // We need handle mutliple selects differently
      // https://stackoverflow.com/a/1177618
      if (!props.multiple) {
        this.props.changeInput(e);
        return;
      }

      // e.target.options[0].selected = false;
      let values = [...e.target.options]
        .filter(o => o.selected && o.value !== 'All')
        .map(o => o.value);

      // If 'All' is selected only send that value
      // selectedIndex is first selected in list
      const index = e.target.options.selectedIndex;

      if (index === -1) {
        // Nothing was selcted - send All
        values = ['All'];
      } else if (index === 0 && values.length === 0) {
        // Only all was added to the selection
        debug('all added to more selected');
        values = ['All'];
      } else {
        debug('other', index, values.length);
      }

      debug(index, 'props', props.value, 'selected', values);

      //   // hackkkkkk
      const o = _.set({}, 'target.value', values);
      props.changeInput(o);
    };
  }

  render() {
    const options: string[] = _.get(this.props, 'options', []);
    const canRevert =
      this.props.changed || deepDiffer(this.props.value, this.props.defaultVal);

    // debug(this.props.value, this.props.defaultVal);

    const recommendedDiv = (
      <RevertInput
        className={fieldWrapperClasses.inputGroupDefault}
        value={this.props.defaultVal}
        enable={canRevert}
        onClick={this.props.revertInput}
      />
    );

    const { multiple, value } = this.props;

    const nullFixVal = multiple && value == null ? [] : value;

    return branch(
      this.props.error.length === 0,
      <Aux>
        <Col sm={process.env.REACT_APP_LEFT_PANE_SIZE}>
          <div className="d-flex">{this.props.fieldName}</div>
        </Col>
        <Col>
          <div className="d-flex">
            {this.props.tooltip ? this.props.tooltip : <div>&nbsp;</div>}
            <FormGroup className="mb-0" style={{ flex: '1 1 auto' }}>
              <Input
                type="select"
                name="selectMulti"
                onChange={this.onChangeHandler}
                value={nullFixVal}
                multiple={multiple}
              >
                {options &&
                  options.map(i => (
                    <option key={i} value={i}>
                      {i}
                    </option>
                  ))}
              </Input>
            </FormGroup>
          </div>
          <div
            className={fieldWrapperClasses.inputGroupColumn}
            style={{ justifyContent: 'flex-end' }}
          >
            {recommendedDiv}
          </div>
          <div>{this.props.warning}</div>
        </Col>
      </Aux>,
      <Col sm={12}>
        <div className="d-flex">
          {this.props.fieldName}
          {this.props.tooltip}
        </div>
        <p>{this.props.error}</p>
        <button className="btn btn-link p-0" onClick={this.props.revertInput}>
          Clear previously selected package.
        </button>
      </Col>,
    );
  }
}

export default FieldDropdown;



// WEBPACK FOOTER //
// ./src/components/FieldDropdown/FieldDropdown.js